import React from "react";
import FormField from "./FormField";

export default function FormSection({
  title,
  fields,
  formData,
  errors,
  onChange,
  insertAfterField,
  insertBeforeField, 
  sectionDescription,
}) {
  const disableMainFields = formData.non_sa_main_id !== true;
  const disablePatientFields = formData.non_sa_patient_id !== true;

  return (
    <>
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 mt-10 border-b-2 pb-2 bg-white sticky top-0 z-20">
        {title}
      </h2>
      {sectionDescription && (
        <div className="mb-4 mt-1 text-gray-700 font-medium">
          {sectionDescription}
        </div>
      )}
      {fields.map((field) => {
        const disabled = [
          "patient_date_of_birth",
          "patient_gender",
          "patient_age",
        ].includes(field.name)
          ? disablePatientFields
          : ["main_date_of_birth", "main_gender"].includes(field.name)
          ? disableMainFields
          : false;

        return (
          <React.Fragment key={field.name}>
            {insertBeforeField?.[field.name]} {/* Add this line */}
            <FormField
              field={{ ...field, disabled }}
              formData={formData}
              value={formData[field.name]}
              error={errors[field.name]}
              onChange={onChange}
            />
            {insertAfterField?.[field.name]}
          </React.Fragment>
        );
      })}
    </>
  );
}
